const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThoracicSurgery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M16.863,12.253c0,0-0.545-3.591,1.739-2.574 c0,0,5.275,2.075,4.367,9.696c0,0-2.483,1.074-5.146-0.619C17.824,18.757,16.89,17.44,16.863,12.253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M15.276,12.253c0,0,0.546-3.591-1.741-2.574 c0,0-5.274,2.075-4.365,9.696c0,0,3.234,0.906,5.145-0.619C14.315,18.757,15.251,17.44,15.276,12.253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M21.51,16.599 c-0.034-0.052-0.724-1.101-2.332-1.727c1.384-0.201,2.195-0.974,2.235-1.014c0.062-0.06,0.061-0.157-0.004-0.215 c-0.032-0.029-0.073-0.043-0.112-0.043c-0.044,0-0.085,0.016-0.116,0.046c-0.012,0.011-1.088,1.031-2.832,0.965 c-0.002,0-0.004,0.001-0.006,0.001c-0.016-0.004-0.034-0.009-0.052-0.013c-0.031-0.01-0.358-0.106-0.736-0.329 c0.514-0.039,1.005-0.239,1.44-0.59c0.43-0.349,0.652-0.723,0.66-0.738c0.045-0.074,0.018-0.166-0.062-0.207 c-0.027-0.013-0.053-0.019-0.079-0.019c-0.057,0-0.114,0.028-0.142,0.079c-0.002,0.003-0.211,0.348-0.599,0.662 c-0.501,0.4-1.059,0.569-1.657,0.502c-0.47-0.402-0.732-0.895-0.777-1.471v-7.02L16.048,4.77h-0.034l-0.291,0.69v7.028 c-0.048,0.576-0.309,1.069-0.778,1.471c-0.601,0.067-1.158-0.102-1.656-0.502c-0.391-0.314-0.598-0.658-0.599-0.662 c-0.03-0.051-0.085-0.079-0.142-0.079c-0.027,0-0.054,0.006-0.08,0.019c-0.078,0.041-0.107,0.133-0.063,0.207 c0.009,0.016,0.231,0.389,0.663,0.738c0.434,0.351,0.923,0.551,1.439,0.59c-0.376,0.223-0.705,0.319-0.738,0.329 c-0.017,0.004-0.033,0.009-0.05,0.013c-0.002,0-0.003-0.001-0.007-0.001c-1.744,0.066-2.82-0.954-2.83-0.965 c-0.032-0.03-0.075-0.046-0.118-0.046c-0.041,0-0.081,0.014-0.112,0.043c-0.065,0.058-0.067,0.155-0.004,0.215 c0.041,0.039,0.851,0.812,2.236,1.014c-1.608,0.625-2.299,1.675-2.332,1.727c-0.047,0.072-0.021,0.167,0.056,0.21 c0.077,0.043,0.176,0.019,0.223-0.052c0.009-0.015,0.911-1.376,3.021-1.861l0.006-0.002c0.009-0.003,0.093-0.026,0.227-0.076 c-0.406,0.502-0.697,0.967-0.869,1.391c-0.096,0.234-0.14,0.422-0.157,0.564c-0.021,0.169,0.149,0.302,0.322,0.253l-0.006-0.049 c-0.003-0.008-0.181-0.763,1.459-2.537l0,0c0.011-0.002,0.02-0.004,0.03-0.008c-0.002-0.005-0.002-0.009-0.004-0.014 c0.013-0.008,0.024-0.016,0.037-0.024c0.648-0.449,1.039-1.048,1.137-1.74c0.096,0.692,0.486,1.292,1.136,1.74 c0.01,0.008,0.023,0.016,0.035,0.024c-0.002,0.005-0.002,0.009-0.002,0.014c0.008,0.004,0.018,0.006,0.028,0.008l0,0 c1.642,1.774,1.501,2.487,1.452,2.586l0,0c0.244,0.038,0.345-0.084,0.323-0.253c-0.018-0.142-0.063-0.33-0.158-0.564 c-0.173-0.424-0.463-0.889-0.869-1.391c0.133,0.05,0.217,0.073,0.228,0.076l0.006,0.002c2.11,0.485,3.013,1.846,3.021,1.861 c0.046,0.071,0.146,0.095,0.223,0.052C21.531,16.766,21.557,16.671,21.51,16.599z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M15.994,2.942c0,0,0.424,4.276-3.467,5.816 c0,0-4.418,1.668-4.507,4.083v0.888"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M16.006,2.942c0,0-0.424,4.276,3.467,5.816 c0,0,4.418,1.668,4.507,4.083v0.97"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M16.006,29.649c0,0-0.424-4.275,3.467-5.817 c0,0,4.418-1.668,4.507-4.082v-0.821"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M15.994,29.649c0,0,0.424-4.275-3.467-5.817 c0,0-4.418-1.668-4.507-4.082v-0.821"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "30.431,15.766 28.717,15.766  27.426,13.898 23.709,13.879 23.709,14.899 26.578,14.899 26.578,15.766 23.709,15.766 23.709,16.883 26.54,16.883 26.54,17.672  23.709,17.672 23.709,18.752 27.426,18.752 28.717,16.883 30.431,16.883  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "1.741,15.75 3.456,15.75  4.746,13.882 8.463,13.863 8.463,14.883 5.593,14.883 5.593,15.75 8.463,15.75 8.463,16.867 5.632,16.867 5.632,17.656  8.463,17.656 8.463,18.736 4.746,18.736 3.456,16.867 1.741,16.867  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThoracicSurgery);
export default __webpack_public_path__ + "static/media/thoracic_surgery.4a93bc0cb36dc939388e474d8dcd605e.svg";
export { ForwardRef as ReactComponent };